/**
 * @author spidersharma / http://eduperiment.com/
 Inspired from Unreal Engine::
 https://docs.unrealengine.com/latest/INT/Engine/Rendering/PostProcessEffects/Bloom/
 */
import * as THREE from 'three'
import renderer from '../../../../renderer'
import config from '../../../../config'
import Triangle from '../../../../globals/triangle'

import {FBO_DEBUG} from '../../../../globals/constants'

import emitter from '../../../../emitter'


import {
	DEBUG
} from '../../../../globals/constants'
var resx, resy;

let opts = {

	threshold: 0,
	bloomStrength: 0,
	bloomRadius: 0
}

import FBOHELPER from '../../../../globals/fbohelper'

export default class UnrealBloomPass {

	constructor(resolution, options){

		var strength = options.strength
		var radius = options.radius
		var threshold = options.threshold

		this.scene = new THREE.Scene()
	
		this.camera = new THREE.OrthographicCamera(- 1, 1, 1, - 1, 0, 1);

		this.quad = new THREE.Mesh(Triangle, new THREE.MeshBasicMaterial())

		this.scene.add(this.quad)

		this.bloomPower = 1
	
		this.strength = ( strength !== undefined ) ? strength : 1;
		this.radius = radius;
		this.threshold = threshold;


		this.resolution = ( resolution !== undefined ) ? new THREE.Vector2(resolution.x, resolution.y) : new THREE.Vector2(256, 256);

		// render targets
		var pars = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBAFormat };
		this.renderTargetsHorizontal = [];
		this.renderTargetsVertical = [];
		this.nMips = 5;
		resx = Math.round(this.resolution.x/2);
		resy = Math.round(this.resolution.y/2);

		for( var i=0; i<this.nMips; i++) {

			var renderTarget = new THREE.WebGLRenderTarget( resx, resy, pars );

			if(FBO_DEBUG){
						
				FBOHELPER.attach(renderTarget, 'renderTargetH' + i)

			}

			renderTarget.texture.name = "UnrealBloomPass.h" + i;
			renderTarget.texture.generateMipmaps = false;

			this.renderTargetsHorizontal.push(renderTarget);

			var renderTarget = new THREE.WebGLRenderTarget( resx, resy, pars );

			if(FBO_DEBUG){
						
				FBOHELPER.attach(renderTarget, 'renderTargetV' + i)

			}

			renderTarget.texture.name = "UnrealBloomPass.v" + i;
			renderTarget.texture.generateMipmaps = false;

			this.renderTargetsVertical.push(renderTarget);

			resx = Math.round(resx/2);

			resy = Math.round(resy/2);

		}

		// if ( THREE.LuminosityHighPassShader === undefined )
		// 	console.error( "THREE.UnrealBloomPass relies on THREE.LuminosityHighPassShader" );

		// var highPassShader = THREE.LuminosityHighPassShader;
		// this.highPassUniforms = THREE.UniformsUtils.clone( highPassShader.uniforms );

		// this.highPassUniforms[ "luminosityThreshold" ].value = threshold;
		// this.highPassUniforms[ "smoothWidth" ].value = 0.01;


		// this.materialHighPassFilter = new THREE.ShaderMaterial( {
		// 	uniforms: this.highPassUniforms,
		// 	vertexShader:  highPassShader.vertexShader,
		// 	fragmentShader: highPassShader.fragmentShader,
		// 	side: 2,

		// 	defines: {}
		// } );

	

		this.separableBlurMaterials = [];
		var kernelSizeArray = [3, 5, 7, 9, 11];
		var resx = Math.round(this.resolution.x/2);
		var resy = Math.round(this.resolution.y/2);

		for( var i=0; i<this.nMips; i++) {

			this.separableBlurMaterials.push(this.getSeperableBlurMaterial(kernelSizeArray[i]));
			this.separableBlurMaterials[i].uniforms[ "texSize" ].value = new THREE.Vector2(resx, resy);
			this.separableBlurMaterials[i].side = 2
			resx = Math.round(resx/2);

			resy = Math.round(resy/2);
		}

		this.compositeMaterial = this.getCompositeMaterial(this.nMips);
		this.compositeMaterial.side = 2
		this.compositeMaterial.uniforms["blurTexture1"].value = this.renderTargetsVertical[0].texture;
		this.compositeMaterial.uniforms["blurTexture2"].value = this.renderTargetsVertical[1].texture;
		this.compositeMaterial.uniforms["blurTexture3"].value = this.renderTargetsVertical[2].texture;
		this.compositeMaterial.uniforms["blurTexture4"].value = this.renderTargetsVertical[3].texture;
		this.compositeMaterial.uniforms["blurTexture5"].value = this.renderTargetsVertical[4].texture;
		this.compositeMaterial.uniforms["bloomStrength"].value = strength;
		this.compositeMaterial.uniforms["bloomRadius"].value = 0.1;
		this.compositeMaterial.needsUpdate = true;

		var bloomFactors = [1.0, 0.8, 0.6, 0.4, 0.2];
		this.compositeMaterial.uniforms["bloomFactors"].value = bloomFactors;
		this.bloomTintColors = [new THREE.Vector3(1,1,1), new THREE.Vector3(1,1,1), new THREE.Vector3(1,1,1)
													,new THREE.Vector3(1,1,1), new THREE.Vector3(1,1,1)];
		this.compositeMaterial.uniforms["bloomTintColors"].value = this.bloomTintColors;
	
		opts.threshold = this.threshold
		opts.bloomStrength = this.strength
		opts.bloomRadius = this.radius

		// console.log(gui)

		// if(DEBUG){

		// 	let folder = gui.addFolder('postprocessing')

		// 	folder.addObserver(opts, 'bloomStrength').step(0.01).listen()

		// 	folder.addObserver(opts, 'bloomRadius').step(0.01).listen()
		// }

		this.output = this.renderTargetsHorizontal[0].texture;

		emitter.on('bloomRadius', (val)=> { opts.bloomRadius = val })
		emitter.on('bloomStrength', (val)=> { opts.bloomStrength = val })
	}

	dispose() {
		for( var i=0; i< this.renderTargetsHorizontal.length(); i++) {
			this.renderTargetsHorizontal[i].dispose();
		}
		for( var i=0; i< this.renderTargetsVertical.length(); i++) {
			this.renderTargetsVertical[i].dispose();
		}
	}

	setSize(width, height ) {

		let ratio = config.devicePixelRatio == 1 ? 2 : 1

		var resx = Math.round(width / 2 * ratio);
		var resy = Math.round(height / 2 * ratio);

		for( var i=0; i<this.nMips; i++) {

			this.renderTargetsHorizontal[i].setSize(resx, resy);
			this.renderTargetsVertical[i].setSize(resx, resy);

			this.separableBlurMaterials[i].uniforms[ "texSize" ].value = new THREE.Vector2(resx, resy);

			resx = Math.round(resx/2);
			resy = Math.round(resy/2);

		}
	}

	render( readBuffer ) {

		var inputRenderTarget = readBuffer;

		for(var i=0; i<this.nMips; i++) {

			this.quad.material = this.separableBlurMaterials[i];

			this.separableBlurMaterials[i].uniforms[ "colorTexture" ].value = inputRenderTarget.texture;

			this.separableBlurMaterials[i].uniforms[ "direction" ].value = new THREE.Vector2(1.0, 0.0 );

			renderer.renderLIGHT(this.scene, this.camera, this.quad, this.renderTargetsHorizontal[i], false )

			this.separableBlurMaterials[i].uniforms[ "colorTexture" ].value = this.renderTargetsHorizontal[i].texture;

			this.separableBlurMaterials[i].uniforms[ "direction" ].value = new THREE.Vector2( 0, 1.0);

			renderer.renderLIGHT(this.scene, this.camera, this.quad, this.renderTargetsVertical[i], false )

			inputRenderTarget = this.renderTargetsHorizontal[i];

		}

		// Composite All the mips
		this.quad.material = this.compositeMaterial;

		this.compositeMaterial.uniforms.bloomStrength.value = opts.bloomStrength;

		this.compositeMaterial.uniforms.bloomRadius.value = opts.bloomRadius;

		this.compositeMaterial.uniforms["bloomTintColors"].value = this.bloomTintColors;
		
		renderer.renderLIGHT(this.scene, this.camera, this.quad, this.renderTargetsHorizontal[0] )

	}

	getSeperableBlurMaterial(kernelRadius) {

		return new THREE.ShaderMaterial( {

			defines: {
				"KERNEL_RADIUS" : kernelRadius,
				"SIGMA" : kernelRadius
			},

			uniforms: {
				"colorTexture": { value: null },
				"texSize"	  : { value: new THREE.Vector2( 0.5, 0.5 ) },
				"direction"	  : { value: new THREE.Vector2( 0.5, 0.5 ) }
			},

			vertexShader:
				"varying vec2 vUv;\n\
				void main() {\n\
					vUv = vec2(0.5)+(position.xy)*0.5;\n\
					gl_Position = vec4( position.xy, 0.0,  1.0 );\n\
				}",

			fragmentShader: require('./blur.glsl')
				
		} );
	}

	getCompositeMaterial(nMips) {

		return new THREE.ShaderMaterial( {

			defines:{
				"NUM_MIPS" : nMips
			},

			uniforms: {
				"blurTexture1": { value: null },
				"blurTexture2": { value: null },
				"blurTexture3": { value: null },
				"blurTexture4": { value: null },
				"blurTexture5": { value: null },
				"dirtTexture": { value: null },
				"bloomStrength" : { value: 1.0 },
				"bloomFactors" : { value: null },
				"bloomTintColors" : { value: null },
				"bloomRadius" : { value: 0.0 }
			},

			
			

			vertexShader:
				"varying vec2 vUv;\n\
				void main() {\n\
					vUv = vec2(0.5)+(position.xy)*0.5;\n\
					gl_Position = vec4( position.xy, 0.0,  1.0 );\n\
				}",

			fragmentShader: require('./frag.glsl')
		} );
	}


}



// WEBPACK FOOTER //
// ./src/scripts/Trail/modules/postprocessing/quad/unrealbloom/index.js